<template>
  <div style="height: calc(100dvh - var(--header-h)); padding: 16px 0">
    <div
      v-if="pending"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      "
    >
      <div class="spinner" />
    </div>
    <div
      v-else-if="mapError"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        gap: 16px;
        font-family: var(--mono);
        font-size: 12px;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: var(--danger);
      "
    >
      <span>Impossible de charger la carte</span>
      <button class="btn" @click="() => refreshMap()">Réessayer</button>
    </div>
    <EventsByCountry v-else :events-by-departements="eventsByDepartements" />
  </div>
</template>

<script setup lang="ts">
import { API_ENDPOINTS } from '~/config/api';

definePageMeta({ layout: 'search' });

useSeoMeta({
  title:
    'Carte des Compétitions CrossFit par Département | Crossfit Event Scanner',
  description:
    'Découvrez les compétitions de CrossFit en France par département sur notre carte interactive. Trouvez facilement les événements près de chez vous.',
});

const { fetchWithAuth } = useApiConfig();
const { add: notify } = useNotification();

interface DepartementStat {
  code: string;
  name: string;
  count: number;
}

const {
  data: eventsByDepartements,
  pending,
  error: mapError,
  refresh: refreshMap,
} = useAsyncData<DepartementStat[]>(
  'events-by-departements',
  () => fetchWithAuth<DepartementStat[]>(API_ENDPOINTS.EVENT_BY_DEPARTMENTS),
  { default: () => [] },
);

watch(mapError, (error) => {
  if (error) notify(extractApiErrorMessage(error), 'error');
});
</script>
